import { connect } from 'react-redux';

import LoadingStateProvider from '../../../../components/LoadingStateProvider';

const mapStateToProps = ({ loading }) => {
  return loading;
};

export default connect(mapStateToProps)(LoadingStateProvider);
